import { render, staticRenderFns } from "./CustomerNoticeLetterList.vue?vue&type=template&id=2aa4f2ba&scoped=true&"
import script from "./CustomerNoticeLetterList.vue?vue&type=script&lang=ts&"
export * from "./CustomerNoticeLetterList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa4f2ba",
  null
  
)

export default component.exports